import { ELEMENT_CODE_BLOCK, ELEMENT_TD, } from '@udecode/plate';
export const softBreakPlugin = {
    options: {
        rules: [
            { hotkey: 'shift+enter' },
            {
                hotkey: 'enter',
                query: {
                    allow: [ELEMENT_CODE_BLOCK, ELEMENT_TD],
                },
            },
        ],
    },
};
//# sourceMappingURL=softBreakPlugin.js.map